import Vue from 'vue'
import Router from 'vue-router'
import SignIn from './views/SignIn.vue'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'SignIn',
      component: SignIn
    },
    {
      path: '/home',
      name: 'home',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Home.vue')
    },
    {
      path: '/movies',
      name: 'movies',
      props: true,
      component: () => import('./views/Movie.vue')
    },
    {
      path: '/staff',
      name: 'staff',
      props: true,
      component: () => import('./views/Staff.vue')
    },
    {
      path: '/rights',
      name: 'rights',
      props: true,
      component: () => import('./views/Right.vue')
    },
    {
      path: '/refreshments',
      name: 'refreshments',
      props: true,
      component: () => import('./views/Refreshment.vue')
    },
    {
      path: '/tickets',
      name: 'tickets',
      props: true,
      component: () => import('./views/Ticket.vue')
    },
    {
      path: '/tickets/tickets-staff',
      name: 'tickets-staff',
      props: true,
      component: () => import('./components/Ticket/TicketStaff.vue')
    },
    {
      path: '/tickets/tickets-user',
      name: 'tickets-user',
      props: true,
      component: () => import('./components/Ticket/TicketUser.vue')
    },
    {
      path: '/tickets/tickets-refreshment',
      name: 'tickets-refreshment',
      props: true,
      component: () => import('./components/Ticket/TicketRefreshment.vue')
    },
    {
      path: '/campus',
      name: 'campus',
      props: true,
      component: () => import('./views/Campus.vue')
    },
    {
      path: '/campus/movie',
      name: 'campus-movie',
      props: true,
      component: () => import('./views/CampusMovie.vue')
    },
    {
      path: '/watch',
      name: 'watch',
      props: true,
      component: () => import('./views/Watch.vue')
    },
  ]
})
